import { render, staticRenderFns } from "./OrgProfile.vue?vue&type=template&id=44c0a6a2&"
import script from "./OrgProfile.vue?vue&type=script&lang=js&"
export * from "./OrgProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports